// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2tmzl","obliqueLineWrap":"membershipbadge_obliqueLineWrap__QO8jN","obliqueLine":"membershipbadge_obliqueLine__2H9Et"};